import { render, staticRenderFns } from "./academic-details-show.vue?vue&type=template&id=73d21b20&scoped=true&"
import script from "./academic-details-show.vue?vue&type=script&lang=js&"
export * from "./academic-details-show.vue?vue&type=script&lang=js&"
import style0 from "./academic-details-show.vue?vue&type=style&index=0&id=73d21b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d21b20",
  null
  
)

export default component.exports